import { TagService } from '@/services/tag.service';
import { queryOptions } from '@tanstack/react-query';

export const listTagsQuery = queryOptions({
  queryKey: ['list-tags'],
  queryFn: TagService.list,
});

export const listTagsWithRelationsQuery = queryOptions({
  queryKey: ['list-tags-with-relations'],
  queryFn: TagService.listWithRelationsCount,
});
